import type { CellContext } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const StackNameCell = ({ cell }: CellContext<any, unknown>) => {
  const { t } = useTranslation();
  const { row } = cell;

  const stackName = useMemo(() => {
    if (row.original.stackName === "not_booked") {
      return t("not_booked");
    }

    return row.original.stackName;
  }, [row.original.stackName]);

  return <div>{stackName || "-"}</div>;
};
